export default __webpack_public_path__ + "static/ar-66dfba3195e4eb90108d4e5122f5cd78.svg";